__turbopack_context__.v({
  "close": "SimulationLayouts-module-scss-module__agRDpW__close",
  "content": "SimulationLayouts-module-scss-module__agRDpW__content",
  "current-step": "SimulationLayouts-module-scss-module__agRDpW__current-step",
  "header": "SimulationLayouts-module-scss-module__agRDpW__header",
  "icon": "SimulationLayouts-module-scss-module__agRDpW__icon",
  "is-full-width": "SimulationLayouts-module-scss-module__agRDpW__is-full-width",
  "is-proposition-step": "SimulationLayouts-module-scss-module__agRDpW__is-proposition-step",
  "logo": "SimulationLayouts-module-scss-module__agRDpW__logo",
  "logo-link": "SimulationLayouts-module-scss-module__agRDpW__logo-link",
  "previous": "SimulationLayouts-module-scss-module__agRDpW__previous",
  "simulation": "SimulationLayouts-module-scss-module__agRDpW__simulation",
  "single-col": "SimulationLayouts-module-scss-module__agRDpW__single-col",
  "usp": "SimulationLayouts-module-scss-module__agRDpW__usp",
  "usps": "SimulationLayouts-module-scss-module__agRDpW__usps",
});
